import Vue from 'vue';
import {VueMasonryPlugin} from 'vue-masonry';
import Vuex from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);
Vue.use(VueMasonryPlugin);

export default new Vuex.Store({
    state: {
        questions: {
            data: [],
            dataLoading: true,
            categories: [],
            categoriesLoading: true,
            categoryFilter: [],
            searchQuery: null,
            searchResults: [],
            searchLoading: false,
            hasError: false,
            hasLoaded: false,
            selectedQuestion: null,
        },
        offers: {
            data: [],
            dataIsLoading: true,
            categories: [],
            categoriesIsLoading: true,
            locations: [],
            locationsIsLoading: true,
            hasError: false,
        },
        contributors: {
            data: [],
            dataIsLoading: true,
            hasError: false,
        },
        events: {
            data: [],
            dataIsLoading: true,
            hasError: false,
        },
        projects: {
            data: [],
            dataIsLoading: true,
            hasError: false,
        },
        overlay: {
            isVisible: false,
            currentPageIndex: 0,
            pages: [],
            navDirection: null,
        },
        layout: {
            siteHeaderMode: 'transparent',
            siteFooterVisability: false,
            mainNav: null,
            mainNavIsLoading: false,
            mainNavhasError: false,
            footerNav: null,
            footerNavIsLoading: false,
            footerNavHasError: false,
        }
    },
    actions,
    getters,
    mutations,
});